"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCookie = void 0;
const types_1 = require("../types");
function formatCookie(key, value, config) {
    if (key.trim() === '') {
        throw new Error('Key may not be empty');
    }
    return [
        `${key}=${value}`,
        ...Object.entries(config !== null && config !== void 0 ? config : {}).map(([configKey, configValue]) => {
            if (typeof configValue === 'undefined' || configValue === null) {
                return;
            }
            if (configValue === true) {
                // set as flag, e.g. 'Secure'
                return configKey;
            }
            // Convert to proper HTTP format
            // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Date
            if (configValue instanceof Date) {
                configValue = configValue.toUTCString();
            }
            return `${configKey}=${configValue}`;
        }),
    ]
        .filter(types_1.isDefined)
        .join('; ');
}
exports.formatCookie = formatCookie;
